import { action } from "typesafe-actions";
import { Audit, AuditActionTypes } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(AuditActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: Audit) =>
  action(AuditActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: any) =>
  action(AuditActionTypes.FETCH_ERROR, error);
